import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { a as e } from "../../../chunks/vec2.js";

var t = /*#__PURE__*/function () {
  function t(e, _t, i) {
    _classCallCheck(this, t);

    this.maxSize = e, this.tileInfoView = _t, this.removedFunc = i, this._tilePerId = new Map(), this._tileKeysPerLevel = [];
  }

  _createClass(t, [{
    key: "has",
    value: function has(e) {
      return this._tilePerId.has(e);
    }
  }, {
    key: "get",
    value: function get(e) {
      return this._tilePerId.get(e);
    }
  }, {
    key: "pop",
    value: function pop(e) {
      var _t2 = this._tilePerId.get(e);

      if (!_t2) return null;
      var s = _t2.key.level,
          r = this._tileKeysPerLevel[s];
      i(this._tilePerId, e);

      for (var _i = 0; _i < r.length; _i++) {
        if (r[_i].id === e) {
          r.splice(_i, 1);
          break;
        }
      }

      return _t2.visible = !0, _t2;
    }
  }, {
    key: "add",
    value: function add(e) {
      e.visible = !1;
      var _t3 = e.key,
          i = _t3.id;
      if (this._tilePerId.has(i)) return;

      this._tilePerId.set(i, e);

      var s = _t3.level;
      this._tileKeysPerLevel[s] || (this._tileKeysPerLevel[s] = []), this._tileKeysPerLevel[s].push(_t3);
    }
  }, {
    key: "prune",
    value: function prune(e, _t4, i) {
      var s = this._tilePerId.size;
      if (s <= this.maxSize) return;
      var r = this._tileKeysPerLevel.length - 1;

      for (; s > this.maxSize && r >= 0;) {
        r !== e && (s = this._pruneAroundCenterTile(s, _t4, i, r)), r--;
      }

      s > this.maxSize && (s = this._pruneAroundCenterTile(s, _t4, i, e));
    }
  }, {
    key: "_pruneAroundCenterTile",
    value: function _pruneAroundCenterTile(_t5, i, s, r) {
      var l = this._tileKeysPerLevel[r];
      if (!l || 0 === l.length) return _t5;
      var _this$tileInfoView$ti = this.tileInfoView.tileInfo,
          n = _this$tileInfoView$ti.size,
          h = _this$tileInfoView$ti.origin,
          o = s * n[0],
          u = s * n[1],
          d = [0, 0],
          _ = [0, 0];

      for (l.sort(function (_t6, s) {
        return d[0] = h.x + o * (_t6.col + .5), d[1] = h.y - u * (_t6.row + .5), _[0] = h.x + o * (s.col + .5), _[1] = h.y - u * (s.row + .5), e(d, i) - e(_, i);
      }); l.length > 0;) {
        var _e = l.pop();

        if (this._removeTile(_e.id), --_t5 === this.maxSize) break;
      }

      return _t5;
    }
  }, {
    key: "_removeTile",
    value: function _removeTile(e) {
      var _t7 = this._tilePerId.get(e);

      this.removedFunc && this.removedFunc(_t7), i(this._tilePerId, e);
    }
  }]);

  return t;
}();

function i(e, t) {
  e.delete(t);
}

export { t as default };